// ═══════════════════════════════════════════════
// 한국어 번역
// ═══════════════════════════════════════════════
const ko = {
  lang: 'ko',
  langName: '한국어',
  currency: '₩',
  currencyRate: 1, // 기준 통화

  // 앱 전역
  app: {
    title: '자재관리 ERP',
    subtitle: 'AI 기반 스마트 자재관리 시스템',
    poweredBy: 'Powered by WindyFlo',
  },

  // 사이드바
  sidebar: {
    dashboard: '대시보드',
    materials: '자재 관리',
    inventory: '재고 현황',
    orders: '주문 관리',
    suppliers: '공급업체',
    reports: '보고서',
    settings: '설정',
    admin: '관리자',
    sysAdmin: '시스템 관리자',
    expand: '펼치기',
    collapse: '접기',
  },

  // 탑바
  topbar: {
    searchPlaceholder: '자재, 주문, 재고 검색...',
    notifications: '알림',
    markAllRead: '모두 읽음',
    viewAll: '모든 알림 보기',
    profile: '내 프로필',
    settings: '설정',
    logout: '로그아웃',
    notif1: '재고 부족 알림: A-101 품목',
    notif2: '신규 주문 접수: PO-2024-001',
    notif3: '월간 보고서 생성 완료',
    timeAgo1: '5분 전',
    timeAgo2: '30분 전',
    timeAgo3: '1시간 전',
  },

  // 대시보드
  dashboard: {
    title: '대시보드',
    totalItems: '총 품목 수',
    totalInventory: '총 재고량',
    needOrder: '발주 필요',
    totalLoss: '불량 손실',
    invStatus: '재고 상태 분포',
    statusNormal: '정상',
    statusWarning: '주의',
    statusOrder: '발주필요',
    alertTitle: '긴급 알림',
    alertNeedOrder: '발주 필요 품목',
    alertItems: '개 품목이 재고 부족 상태입니다.',
    alertDefect: '불량 손실',
    alertDefectDesc: '불량으로 인한 총 손실액입니다.',
    orderFulfill: '주문 충족 현황',
    orderTotal: '총 주문',
    orderFulfilled: '충족',
    orderShortage: '부족',
    fulfillRate: '충족률',
    vendorPerf: '공급업체 성과',
    items: '개',
    count: '건',
    won: '원',
    day: '일',
    ea: 'EA',
    pcs: '개',
  },

  // 공통 테이블/그리드
  grid: {
    add: '행 추가',
    delete: '삭제',
    copy: '복사',
    export: '내보내기',
    undo: '실행 취소',
    redo: '다시 실행',
    selectedRows: '개 행 선택됨',
    noRows: '데이터가 없습니다',
  },

  // 자재 관리
  materials: {
    title: '자재 마스터',
    code: '품목코드',
    name: '품목명',
    group: '그룹',
    unit: '단위',
    cost: '원가',
    status: '상태',
    active: '활성',
  },

  // 재고 현황
  inventory: {
    title: '재고 현황',
    code: '품목코드',
    name: '품목명',
    group: '그룹',
    good: 'Good',
    reserved: 'Reserved',
    defect: 'Defect',
    atp: 'ATP',
    cost: '단가',
    value: '재고가치',
    lossAmt: '손실액',
    status: '상태',
    needOrder: '발주필요',
    normal: '정상',
    caution: '주의',
  },

  // 주문 관리
  orders: {
    title: '주문 관리',
    orderId: '주문번호',
    customer: '고객',
    itemCode: '품목코드',
    qty: '수량',
    rule: '규칙',
    date: '일자',
    shortage: '부족',
    fulfilled: '충족',
    unfulfilled: '미충족',
  },

  // 공급업체
  vendors: {
    title: '공급업체',
    vendorName: '공급업체명',
    code: '품목코드',
    name: '품목명',
    moq: 'MOQ',
    lot: 'LOT',
    cost: '단가',
    lt: '리드타임',
    defRate: '불량율',
  },

  // 보고서
  reports: {
    inventory: '재고 종합 분석',
    inventoryDesc: 'AI 재고 현황 분석',
    vendor: '공급업체 성과',
    vendorDesc: 'AI 공급망 평가',
    order: '주문 충족/구매요청',
    orderDesc: 'AI 주문 분석',
    defect: '불량/손실 분석',
    defectDesc: 'AI 품질 분석',
    simulation: '시뮬레이션 보고서',
    simulationDesc: 'AI 시나리오 리포트',
    printPdf: '인쇄 / PDF',
    aiAnalysis: 'AI 분석 실행',
    analyzing: '분석 중...',
    aiDesc: '위 버튼을 클릭하면 AI가 현재 데이터를 분석하여\n인사이트와 개선 제안을 제공합니다.',
    generateReport: 'AI 보고서 생성',
    generating: '보고서 생성 중...',
    simTitle: '재고 시뮬레이션 보고서 생성기',
    simDesc: '시나리오를 설정하고 보고서를 생성하면, AI가 경영진용 분석 리포트를 자동으로 작성합니다.',
    demandChange: '수요 변동',
    ltChange: '리드타임 변동',
    defRateChange: '불량율 변동',
    costChange: '단가 변동',
    presetDemandSurge: '📈 수요 급증 (+30%)',
    presetSupplyDelay: '🚚 공급 지연 시나리오',
    presetQualityDown: '🔴 품질 악화',
    presetInflation: '💰 인플레이션',
    presetWorstCase: '⚠️ 최악의 경우',
    presetImprove: '✅ 개선 시나리오',
    generatedReport: '생성된 보고서',
    dataAnalysis: '📊 데이터 분석',
    simExecution: '🧮 시뮬레이션 실행',
    reportWriting: '📝 보고서 작성',
    reviewDone: '✅ 검토 완료',
  },

  // 보고서 상세 (ReportsPage 내부)
  rpt: {
    // 공통
    group: '품목그룹',
    code: '품목코드',
    name: '품목명',
    count: '품목수',
    qty: '수량',
    unit: '단가',
    total: '합계',
    grade: '등급',
    items: '개',
    cases: '건',
    day: '일',
    won: '원',
    // 재고
    invTitle: '📊 재고 종합 분석 보고서',
    totalItems: '총 품목',
    goodInv: 'Good 재고',
    reserved: 'Reserved',
    defect: 'Defect',
    assetValue: '자산가치',
    defLoss: '불량손실',
    groupInv: '그룹별 재고 현황',
    statusDist: '재고 상태 분포',
    needOrderItems: '발주 필요 품목',
    needOrder: '발주필요',
    normal: '정상',
    caution: '주의',
    // 공급업체
    vendorTitle: '🤝 공급업체 성과 분석 보고서',
    vendor: '공급업체',
    tradeCount: '거래',
    avgCost: '평균 단가',
    avgLt: '평균 리드타임',
    avgDefRate: '평균 불량율',
    tradeDetail: '거래 상세',
    // 주문
    orderTitle: '🛒 주문 충족 분석 및 구매요청서',
    totalOrder: '총 주문',
    fulfilled: '충족',
    unfulfilled: '미충족',
    estOrder: '예상 발주',
    orderAnalysis: '주문별 분석',
    customer: '고객',
    shortage: '부족',
    rule: '규칙',
    autoPoTitle: '📝 자동 구매요청서',
    recommended: '추천처',
    orderQty: '발주량',
    amount: '금액',
    delivery: '납기',
    buyRule: '구매규칙',
    // 불량
    defTitle: '📉 불량/손실 분석 보고서',
    defItems: '불량 품목',
    totalDef: '총 불량',
    totalLoss: '총 손실',
    groupDef: '그룹별 불량',
    defDetail: '상세 (손실액 순)',
    ratio: '비중',
    // 시뮬레이션
    simTitle: '🧪 재고 시뮬레이션 보고서 생성기',
    simDesc: '시나리오를 설정하고 보고서를 생성하면, AI가 경영진용 분석 리포트를 자동으로 작성합니다.',
    demandLabel: '📈 수요 변동',
    ltLabel: '🚚 리드타임 변동',
    defRateLabel: '🔴 불량율 변동',
    costLabel: '💰 단가 변동',
    generateBtn: 'AI 보고서 생성',
    generating: '보고서 생성 중...',
    genReport: '📄 생성된 보고서',
    aiAnalysisBtn: 'AI 분석 실행',
    aiAnalyzing: '분석 중...',
    aiAnalysisLabel: 'AI 분석',
    aiPlaceholder: '위 버튼을 클릭하면 AI가 현재 데이터를 분석하여\n인사이트와 개선 제안을 제공합니다.',
    analyzing: '데이터를 분석하고 있습니다...',
    printPdf: '🖨️ 인쇄 / PDF',
    // 시뮬레이션 프리셋
    presetDemandSurge: '📈 수요 급증 (+30%)',
    presetSupplyDelay: '🚚 공급 지연 시나리오',
    presetQualityDown: '🔴 품질 악화',
    presetInflation: '💰 인플레이션',
    presetWorstCase: '⚠️ 최악의 경우',
    presetImprove: '✅ 개선 시나리오',
    // 시뮬레이션 진행 단계
    stepAnalysis: '📊 데이터 분석',
    stepSimulation: '🧮 시뮬레이션 실행',
    stepWriting: '📝 보고서 작성',
    stepReview: '✅ 검토 완료',
    // 통화/단위
    currencySymbol: '₩',
    // AI 프롬프트 언어
    promptLang: 'ko',
  },

  // 코파일럿
  copilot: {
    title: 'AI 코파일럿',
    subtitle: '개 품목 · 실시간 분석',
    placeholder: '질문을 입력하세요...',
    thinking: '생각 중...',
    welcomeTitle: '무엇을 도와드릴까요?',
    welcomeSub: '품목코드, 재고, 발주, 공급업체 등을 질문해보세요',
    open: 'AI 코파일럿 열기',
    clear: '대화 초기화',
    expand: '확장',
    collapse: '축소',
    close: '닫기',
    homepage: '홈페이지 열기',
    notFound: '해당 질문에 대한 데이터를 찾지 못했습니다.\n\n아래 질문들을 시도해보세요:\n- 재고 현황 알려줘\n- 발주 필요한 것들 알려줘\n- P101011 재고 알려줘',
    prompts: {
      dashboard: ['발주가 필요한 품목들 알려줘', '불량 손실 금액 분석해줘', '가용재고(ATP) 현황 알려줘', '구매 요청서 작성해줘'],
      materials: ['메모리 그룹 품목들 보여줘', '비메모리 품목들 보여줘', 'CSP 계열 품목들 업체별 정보 보여줘', 'P101011 정보 알려줘'],
      inventory: ['재고 현황 전체 알려줘', '발주 필요한 것들 리스트', '불량 재고 리스트 줘봐', 'P202012 재고 알려줘'],
      orders: ['주문들 기반으로 구매 요청서 작성해줘', '주문 충족 현황 알려줘', 'P301011 재고 알려줘'],
      suppliers: ['공급업체 현황 알려줘', 'P301024 발주처 정보 좀', 'P101011 공급업체 비교해줘'],
    },
  },

  // 설정 페이지
  settings: {
    title: '설정',
    desc: '시스템 설정과 사용자 권한을 관리할 수 있습니다.',
    language: '언어 설정',
    langDesc: '인터페이스 언어를 변경합니다.',
  },
};

export default ko;
